<template>
  <div>
    <div class="search">
      <!-- <div class="search-input">
          <el-input v-model="searchName"  placeholder="物业项目">
              <el-button slot="append" icon="el-icon-search" @click="searchKeyWord"></el-button>
          </el-input>
      </div> -->
    </div>
    <el-table
      @cell-click="cellClick"
      :data="tableData"
      style="width: 100%"
      v-loading="loading"
      element-loading-text="数据正在加载中，请稍候"
    >
      <!-- 数据加载的时候显示数据正在加载中，请稍候 -->
      <template slot="empty">
        <span v-if="loading"></span>
        <span v-else>暂无数据</span>
      </template>
      <!--标准编制-->
      <template v-if="columnLabelType == '7'">
        <el-table-column
          align="center"
          prop="actionName"
          label="标准名称"
          min-width="150"
          :key="Math.random()"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="actionFileNum"
          label="标准编号"
          min-width="150"
          :key="Math.random()"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="actionLevel"
          label="标准级别"
          min-width="150"
          :key="Math.random()"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="ranking"
          label="在起草中排名"
          min-width="150"
          :key="Math.random()"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="actionCategory"
          label="编制类别"
          min-width="150"
          :key="Math.random()"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="actionReleaseDate"
          label="发布日期"
          min-width="150"
          :key="Math.random()"
        >
          <template slot-scope="scope">{{
            scope.row.actionReleaseDate | getDate
          }}</template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="actionMaterialDate"
          label="实施日期"
          min-width="150"
          :key="Math.random()"
        >
          <template slot-scope="scope">{{
            scope.row.actionMaterialDate | getDate
          }}</template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="actionLevel"
          label="标准级别"
          min-width="150"
          :key="Math.random()"
        ></el-table-column>
      </template>
      <!--绿色物业星级评价 和 绿色物业示范项目-->
      <template v-else-if="columnLabelType == '4' || columnLabelType == '5'">
        <el-table-column
          align="center"
          prop="eaAreaName"
          label="项目名称"
          min-width="150"
          :key="Math.random()"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="EaAreaType"
          label="项目类型"
          min-width="150"
          :key="Math.random()"
        >
          <template slot-scope="scope">{{
            scope.row.EaAreaType ? scope.row.EaAreaType : '-'
          }}</template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="starLevel"
          label="评价星级"
          min-width="150"
          :key="Math.random()"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="actionFileNum"
          label="证书编号"
          min-width="150"
          :key="Math.random()"
        >
          <template slot-scope="scope">{{
            scope.row.actionFileNum ? scope.row.ActionFileNum : '-'
          }}</template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="overTime"
          label="有效期"
          min-width="150"
          :key="Math.random()"
        >
          <template slot-scope="scope">{{
            scope.row.overTime | getDate
          }}</template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="isDemoProject"
          label="是否示范项目"
          min-width="150"
          :key="Math.random()"
        >
          <template slot-scope="scope">{{
            scope.row.isDemoProject ? '是' : '否'
          }}</template>
        </el-table-column>
      </template>
      <!--表彰信息-->
      <template v-else-if="columnLabelType == '1'">
        <el-table-column
          align="center"
          prop="actionName"
          label="表彰标题"
          min-width="150"
          :key="Math.random()"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="actionFileNum"
          label="表彰文号"
          min-width="150"
          :key="Math.random()"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="actionLevel"
          label="表彰等级"
          min-width="150"
          :key="Math.random()"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="actionOrg"
          label="表彰单位"
          min-width="150"
          :key="Math.random()"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="actionDate"
          label="表彰时间"
          min-width="150"
          :key="Math.random()"
        >
          <template slot-scope="scope">{{
            scope.row.actionDate | getDate
          }}</template>
        </el-table-column>
      </template>
      <!--幸福小区-->
      <template v-else-if="columnLabelType == '2'">
        <el-table-column
          align="center"
          prop="eaAreaName"
          label="项目名称"
          min-width="150"
          :key="Math.random()"
        >
          <template slot-scope="scope">{{
            scope.row.eaAreaName ? scope.row.eaAreaName : '-'
          }}</template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="EaAreaType"
          label="项目类型"
          min-width="150"
          :key="Math.random()"
        >
          <template slot-scope="scope">{{
            scope.row.EaAreaType ? scope.row.EaAreaType : '-'
          }}</template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="actionName"
          label="表彰标题"
          min-width="150"
          :key="Math.random()"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="actionFileNum"
          label="表彰文号"
          min-width="150"
          :key="Math.random()"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="actionLevel"
          label="表彰等级"
          min-width="150"
          :key="Math.random()"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="actionOrg"
          label="表彰单位"
          min-width="150"
          :key="Math.random()"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="actionDate"
          label="表彰时间"
          min-width="150"
          :key="Math.random()"
        >
          <template slot-scope="scope">{{
            scope.row.actionDate | getDate
          }}</template>
        </el-table-column>
      </template>
      <!--其他-->
      <template v-else>
        <el-table-column
          align="center"
          prop="actionFileNum"
          label="文号"
          min-width="150"
        ></el-table-column>
        <el-table-column label="登记时间" align="center" min-width="120">
          <template slot-scope="scope">{{
            scope.row.createDate | getDate
          }}</template>
        </el-table-column>
      </template>
    </el-table>
    <div class="footer">
      <div class="page">
        <ps-page :page="page" @getData="getTableDataByType()"></ps-page>
      </div>
    </div>
  </div>
</template>

<script>
import { Page } from '@/models/page';
import { CreditInformationController } from '@/service/PublicCreditInformation/CreditInformationController.js';

export default {
  name: 'wellHealth',
  props: {
    code: String,
    eaAreaCode: String,
    columnLabel: String,
    objType: Number || String,
    columnLabelType: String || Number,
    peopleName: String,
    certificate: String,
    keyId: String,
  },
  components: {},
  data() {
    return {
      loading: false,
      searchName: '',
      tableData: [],
      page: new Page(),
    };
  },
  filters: {
    getDate(val) {
      if (val) {
        return val.substring(0, 10);
      }
    },
  },
  mounted() {
    console.log(this.page);
    this.CreditInformationController = new CreditInformationController();
    this.getTableData();
  },
  methods: {
    cellClick() {},
    // 搜索
    searchKeyWord() {},
    // 翻页
    getTableDataByType() {
      this.getTableData();
    },
    //获取列表数据eaAreaCode:String, orgCode:String, name:String, iDCard:String, type:int, option:int, startIndex:int, maxSize:int, resultTotalCount:boolean
    getTableData() {
      this.loading = true;
      this.CreditInformationController.GetGoodBehaviorListByDetail(
        this.eaAreaCode,
        this.objType == 1 || this.objType == 3 || this.objType == 5
          ? this.code
          : '',
        this.peopleName,
        this.certificate,
        this.objType,
        this.columnLabelType,
        (this.page.currentPage - 1) * this.page.currtNum,
        this.page.currtNum,
        true
      )
        .then((res) => {
          this.loading = false;
          if (res && res.eaAreaList) {
            this.tableData = res.eaAreaList;
            this.page.getCurrtNum = res.TotalCount;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            type: 'error',
            message: error,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.search {
  padding: 15px 0;
  display: flex;
  align-items: center;

  .search-input {
    flex: 1;
    display: flex;

    .el-input {
      .el-input__inner {
        background-color: rgb(140, 78, 127);
      }
    }
  }
}

.footer {
  display: flex;
  flex-direction: row-reverse;
  margin-right: 10px;

  .fun {
    font-size: 14px;
    color: #409eff;
    cursor: pointer;

    .delete {
      margin-left: 20px;
    }
  }
}
</style>
